import { Component, OnInit, Inject, ViewChildren, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { GlobalService } from '../../services/global.service';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
    selector: 'sd-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.scss']
})

export class VerifyEmailComponent implements OnInit, AfterViewInit {
    type: string = 'email';
    form: UntypedFormGroup;
    formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
    @ViewChildren('formRow') rows: any;



    // //////////////////////////////////////////////////////
    loading: Boolean = true;
    error: Boolean = false;
    errorMsg: String = '';
    success: Boolean = false;
    otpError: Boolean = false;
    otpErrorMsg: String = '';
    otpUpdated = false;
    otpUpdating = false;
    otpSent: Boolean = false;
    verifyOTPError = false;
    verifyOTPErrorMsg: String = '';
    verifyOTPUpdated = false;
    verifyOTPUpdating = false;

    disableResendBtn = false;
    otpMsg: string;

    timerMinute = 2;
    timerSecond = 0;
    sendOTPStart = false;
    sendOtpInterval;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private verifyEmailDialogRef: MatDialogRef<VerifyEmailComponent>,
        private api: ApiService, private router: Router,
        public user: UserService,
        public dialog: DialogService,
        public global: GlobalService,
        private toastrService: ToastrService
    ) {
        this.form = this.toFormGroup(this.formInput);
    }


    toFormGroup(elements) {
        const group: any = {};

        elements.forEach(key => {
            group[key] = new UntypedFormControl('', Validators.required);
        });
        return new UntypedFormGroup(group);
    }


    get otp() { return this.form.get('otp'); }

    ngOnInit() {
        if (this.data.autoSend != false) {
            this.disableResend();
        }
        if(this.data.from !== 'settings'){

            this.resendOtp()
        }
    }

    ngAfterViewInit() {
        let inputElements = document.querySelectorAll('input[type="number"]')
        let firstOtpInput = document.querySelector('input[type="number"]') as HTMLInputElement;
        // firstOtpInput.addEventListener('input', this.splitNumber.bind(this));

        inputElements.forEach(elem => {
            const angularthis = this
            elem.addEventListener('keyup', function (e: KeyboardEvent) {

                const ignoredKeys = ['Shift', 'Tab', 'Meta', 'Alt', 'Control']
                if (ignoredKeys.includes(e.key)) { return };

                (e.key === 'ArrowLeft' || e.key === 'Backspace') && this.previousElementSibling ? this.previousElementSibling.focus() :
                    e.key !== 'Backspace' && this.nextElementSibling ? this.nextElementSibling.focus() : '';

                (<HTMLInputElement>e.target).value.length > 1 ? angularthis.splitNumber(e.target, (<HTMLInputElement>e.target).value) : ''
            });

            elem.addEventListener('focus', function (e) {
                // If the focus element is the first one, do nothing
                if (this === firstOtpInput) return;

                // If value of input 1 is empty, focus it.
                if (firstOtpInput.value == '') {
                    firstOtpInput.focus();
                }

                // If value of a previous input is empty, focus it.
                // To remove if you don't wanna force user respecting the fields order.
                if (this.previousElementSibling.value == '') {
                    this.previousElementSibling.focus();
                }
            });
        })
    }



    splitNumber(el, data) {
        //Getting formcontrolName
        const formControlName = el.getAttribute('formcontrolname')
        this.form.get(formControlName).setValue(data[0])
        // el.value = data[0]
        data = data.substring(1); // remove the first char.
        if (el.nextElementSibling && data.length) {
            // Do the same with the next element and next data
            el.nextElementSibling.focus();
            this.splitNumber(el.nextElementSibling, data);
        }
    };


    closeDialog(res = false) {
        this.verifyEmailDialogRef.close({
            'email': this.user.email,
            'res': res
        });
    }


    onOTPFormSubmit() {

        if (this.form.valid) {
            this.verifyOTPUpdating = true;
            const values = Object.values(this.form.value);
            let inputOTPValue = values.join("").substring(0, 6)
            console.log(inputOTPValue)


            this.api.verifyOTP(inputOTPValue, this.type, this.data.email).subscribe(res => {
                console.log(res);
                this.verifyOTPUpdating = false;

                if (res.result == 'Success' || res.result == 'success') {
                    this.verifyOTPError = false;
                    this.user.isEmailVerified = true;
                    this.verifyOTPUpdated = false;

                    this.user.isEmailVerified = true;
                    this.user.email = this.data.email
                    localStorage.setItem('email', JSON.stringify(this.user.email));
                    localStorage.setItem('isEmailVerified', JSON.stringify(this.user.isEmailVerified));

                    this.closeDialog(true);
                    this.toastrService.success('Email verified successfully');
                    this.global.trackEvent('verify-email-dialog', 'Verify OTP Success');

                    if (this.router.url.indexOf('opportunities/') > -1 && this.router.url.indexOf('/apply') == -1) {
                        this.router.navigate([this.router.url.split('?')[0] + '/apply']);
                    }

                    if (this.data.from == 'checkout') {
                        this.router.navigate(['/subscription/checkout'])
                    } 
                    
                    /** removed by ananya */
                   // else if (this.user.isProMember ==0 || this.user.isProMember ==2) {
                    //    this.dialog.openSubscriptionDialog()
                   // }

                } else {
                    this.verifyOTPError = true;
                    this.verifyOTPErrorMsg = res.result;
                    this.global.trackEvent('very-email-dialog', 'Verify OTP Failure' + this.verifyOTPErrorMsg);
                }
            },
                (err: HttpErrorResponse) => {
                    this.verifyOTPError = true;
                    this.verifyOTPUpdating = false;

                    if (err.error instanceof Error) {
                        this.verifyOTPErrorMsg = 'Client-side error occured';
                        // console.log('Client-side error occured!');
                    } else {
                        this.verifyOTPErrorMsg = 'Invaild OTP';
                        // console.log('Server-side error occured!');
                    }
                });
        }
    }


    resendOtp() {
        this.timerMinute = 2;
        this.timerSecond = 0;

        this.sendOTPStart = true;
        this.timeCount();

        // this.api.updateEmail(this.data.email).subscribe(res => {
        //     if (res.success) {
        //         this.otpMsg = 'OTP sent on your email address.'
        //     } else {
        //         this.verifyOTPErrorMsg = res.error;
        //         this.clearOtpInterval(this.sendOtpInterval)
        //     }
        // })
        const requestData = { email: this.data.email }

        this.api.requestPost(this.api.apiBaseV2, "/change_user_email/", requestData).subscribe(res => {
      
            //console.log(res)
            if (res.success) {
                this.otpMsg = 'OTP sent on your email address.'


            } else {
                this.verifyOTPErrorMsg = res.error;
                this.clearOtpInterval(this.sendOtpInterval)
            }

        })


    }

    clearOtpInterval(intervalName = this.sendOtpInterval) {
        this.sendOTPStart = false;
        clearInterval(intervalName)

    }

    timeCount(timerMinute = 2, timerSecond = 0, timeInterval = 1000) {
        this.timerMinute = timerMinute;
        this.timerSecond = timerSecond;
        this.sendOtpInterval = setInterval(() => {
            if (this.timerMinute >= 0) {
                if (this.timerSecond > 0) {
                    this.timerSecond -= 1;
                } else {
                    if ((this.timerMinute - 1) < 0) {
                        this.clearOtpInterval(this.sendOtpInterval)
                    } else {
                        this.timerMinute -= 1;
                        this.timerSecond = 59;
                    }
                }
            } else {
                this.clearOtpInterval(this.sendOtpInterval)
            }

        }, timeInterval)
    }




    disableResend() {
        this.disableResendBtn = true;
        const angularthis = this;
        if (this.global.isBrowser) {
            (<any>window).setTimeout(function () {
                angularthis.disableResendBtn = false;
            }, 10000);
        }
    }






}
